import {useQuery} from '@tanstack/react-query';
import {apiRequest} from '../../utils/AxiosHelper';
import API from '../../modules/settings/APIs';
import {LossEventStats} from '../../types/events';

export const useEventsStats = (enabled = true) => {
  return useQuery<LossEventStats>({
    queryKey: ['events', 'stats'],
    queryFn: async () => {
      const res = await apiRequest.get(API.events.operations.stats);
      return res.data.data ?? res.data;
    },
    staleTime: 5 * 60 * 1000,
    enabled,
  });
};
